import React from "react";
import { observer } from "mobx-react";
import { EventKeyBettingOffer } from "@gp/models";
import { EventKeyOffer } from "@gp/offer";
import { OutrightOfferRowOffer } from "./OutrightOfferRowOffer";

export const OutrightOfferRow = observer(function OutrightOfferRow(props: {
	eventKey: EventKeyOffer;
	offers: EventKeyBettingOffer[];
}) {
	if (props.offers == null || props.offers.length === 0) {
		return null;
	}

	return (
		<>
			{props.offers.map((tip) => (
				<OutrightOfferRowOffer
					key={tip.id}
					tip={tip}
					eventKey={props.eventKey}
					countryCode={tip.countryCode}
				/>
			))}
		</>
	);
});
